import { render, staticRenderFns } from "./CellsBlock.vue?vue&type=template&id=038778fb&scoped=true"
import script from "./CellsBlock.vue?vue&type=script&lang=js"
export * from "./CellsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038778fb",
  null
  
)

export default component.exports